import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { i18n } from '../../index'
import ExternalEmployeeForm from './ExternalEmployeeForm'
import css from './externalEmployeeDialog.css'
type ExternalEmployeeDialogProps = {
  stationId: string
  isOpen: boolean
  onClose: (...args: Array<any>) => any
}

class ExternalEmployeeDialog extends React.PureComponent<ExternalEmployeeDialogProps> {
  render() {
    const { stationId, isOpen, onClose } = this.props
    return (
      <Dialog
        /* disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
        className={css.component}
      >
        <DialogTitle id='form-dialog-title'>{i18n.t('admin.stations.title.createExternalEmployeeDialog')}</DialogTitle>
        <DialogContent>
          <ExternalEmployeeForm stationId={stationId} onSubmit={onClose} onCancel={onClose} />
        </DialogContent>
      </Dialog>
    )
  }
}

export default ExternalEmployeeDialog
